import { Type } from '@sinclair/typebox';
// M16 — RAG-feeder connector connection surface (HUB-074 §2, HUB-075 §1/§2/§3;
// CONN-01/02/03/07/08). `refreshTokenEnc` is deliberately ABSENT from every
// schema: token material (even encrypted) never leaves the DB row.
/**
 * A designated folder in the connection's sync scope, enriched with per-folder
 * status for the Settings UI (CONN-08; HUB-075 §4). `docCount`/`errorCount`
 * aggregate LIVE ledger rows whose `meta.folderIds` contains this folder id —
 * a file under two designated roots counts in both (documented, acceptable V1).
 */
export const ConnectorFolderSchema = Type.Object({
    id: Type.String(),
    name: Type.String(),
    addedAt: Type.String(),
    /** Live ledger rows with `status = 'synced'` under this folder. */
    docCount: Type.Integer(),
    /** Live ledger rows with `status = 'error'` under this folder. */
    errorCount: Type.Integer(),
});
export const ConnectorConnectionSchema = Type.Object({
    id: Type.String({ format: 'uuid' }),
    provider: Type.String(),
    status: Type.Union([Type.Literal('active'), Type.Literal('credential_invalid')]),
    folders: Type.Array(ConnectorFolderSchema),
    lastSyncedAt: Type.Union([Type.String({ format: 'date-time' }), Type.Null()]),
    lastSyncError: Type.Union([Type.String(), Type.Null()]),
    /** Live synced documents: ledger rows with `deleted_at IS NULL AND status = 'synced'`. */
    docCount: Type.Integer(),
});
export const ConnectorListResponseSchema = Type.Object({
    connections: Type.Array(ConnectorConnectionSchema),
});
export const ConnectorIdParamsSchema = Type.Object({
    id: Type.String({ format: 'uuid' }),
});
export const ConnectorFolderParamsSchema = Type.Object({
    id: Type.String({ format: 'uuid' }),
    folderId: Type.String(),
});
/** Body of POST /connectors/:id/folders — a pasted Drive folder link or bare id (HUB-075 §2). */
export const ConnectorAddFolderBodySchema = Type.Object({
    folder: Type.String(),
});
/** 202 body of POST /connectors/:id/sync — the route never awaits the sync (HUB-075 §3). */
export const ConnectorSyncQueuedResponseSchema = Type.Object({
    status: Type.Literal('queued'),
});
//# sourceMappingURL=connectors.js.map